module.exports = {
  size: 128,
  resolution: 72,
  underline_thickness: 50,
  underline_position: -100,
  max_advance_width: 1070,
  height: 1178,
  descender: -250,
  ascender: 928,
  units_per_EM: 1000,
  style_name: 'Regular',
  family_name: 'Italiana',
  kerning: [],
  glyphs: {
    '0': {
      xoff: 5312,
      width: 4544,
      height: 4224,
      hbx: 384,
      hby: 4160,
      path: [
        ['m', 410, 2048],
        ['q', 410, 2908, 1061, 3518],
        ['q', 1712, 4129, 2678, 4129],
        ['q', 3645, 4129, 4255, 3625],
        ['q', 4866, 3121, 4866, 2048],
        ['q', 4866, 1188, 4215, 577],
        ['q', 3564, -33, 2597, -33],
        ['q', 1630, -33, 1020, 471],
        ['q', 410, 975, 410, 2048],
        ['m', 1065, 2048],
        ['q', 1065, 1016, 1499, 524],
        ['q', 1933, 33, 2613, 33],
        ['q', 3293, 33, 3752, 622],
        ['q', 4211, 1212, 4211, 2048],
        ['q', 4211, 3080, 3776, 3571],
        ['q', 3342, 4063, 2662, 4063],
        ['q', 1982, 4063, 1523, 3473],
        ['q', 1065, 2884, 1065, 2048],
      ],
    },
    '1': {
      xoff: 3264,
      width: 1728,
      height: 4096,
      hbx: 768,
      hby: 4096,
      path: [
        ['m', 2351, 4030],
        ['l', 1966, 4030],
        ['l', 1966, 66],
        ['l', 2458, 66],
        ['l', 2458, 0],
        ['l', 819, 0],
        ['l', 819, 66],
        ['l', 1311, 66],
        ['l', 1311, 4030],
        ['l', 926, 4030],
        ['l', 926, 4096],
        ['l', 2351, 4096],
        ['l', 2351, 4030],
      ],
    },
    '2': {
      xoff: 3584,
      width: 3136,
      height: 4096,
      hbx: 320,
      hby: 4096,
      path: [
        ['m', 1745, 4030],
        ['q', 1122, 4030, 655, 3564],
        ['l', 614, 3613],
        ['q', 1163, 4096, 1765, 4096],
        ['q', 2367, 4096, 2678, 3850],
        ['q', 2990, 3604, 2990, 3108],
        ['q', 2990, 2613, 2408, 1626],
        ['q', 1827, 639, 1114, 66],
        ['l', 2695, 66],
        ['q', 3260, 66, 3375, 393],
        ['l', 3424, 369],
        ['q', 3424, 336, 3367, 258],
        ['q', 3310, 180, 3236, 131],
        ['q', 3039, 0, 2695, 0],
        ['l', 328, 0],
        ['q', 1098, 582, 1716, 1589],
        ['q', 2335, 2597, 2335, 3129],
        ['q', 2335, 4030, 1745, 4030],
      ],
    },
    '3': {
      xoff: 3072,
      width: 2496,
      height: 4928,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 2040, 3310],
        ['q', 2040, 4030, 1507, 4030],
        ['q', 1024, 4030, 483, 3801],
        ['l', 451, 3858],
        ['q', 991, 4096, 1532, 4096],
        ['q', 1810, 4096, 2105, 4014],
        ['q', 2695, 3850, 2695, 3310],
        ['q', 2695, 2884, 2347, 2593],
        ['q', 1999, 2302, 1499, 2138],
        ['q', 1966, 2089, 2293, 1847],
        ['q', 2621, 1606, 2621, 1180],
        ['q', 2621, 754, 2396, 405],
        ['q', 2171, 57, 1819, -180],
        ['q', 1090, -680, 328, -819],
        ['l', 319, -754],
        ['q', 934, -590, 1450, -53],
        ['q', 1966, 483, 1966, 1147],
        ['q', 1966, 1597, 1773, 1822],
        ['q', 1581, 2048, 1327, 2081],
        ['q', 1180, 2023, 1081, 2015],
        ['l', 1049, 2073],
        ['q', 1475, 2204, 1757, 2535],
        ['q', 2040, 2867, 2040, 3310],
      ],
    },
    '4': {
      xoff: 3648,
      width: 3072,
      height: 4928,
      hbx: 192,
      hby: 4096,
      path: [
        ['m', 3236, 66],
        ['l', 3236, 0],
        ['l', 2843, 0],
        ['l', 2744, -819],
        ['l', 2097, -819],
        ['l', 2187, 0],
        ['l', 246, 0],
        ['l', 3178, 4096],
        ['l', 3236, 4063],
        ['q', 2023, 2376, 377, 66],
        ['l', 2195, 66],
        ['l', 2466, 2327],
        ['l', 3121, 2327],
        ['l', 2851, 66],
        ['l', 3236, 66],
      ],
    },
    '5': {
      xoff: 2880,
      width: 2368,
      height: 4928,
      hbx: 128,
      hby: 4096,
      path: [
        ['m', 1786, 1417],
        ['q', 1786, 2638, 590, 2638],
        ['l', 737, 4096],
        ['l', 2179, 4096],
        ['l', 2179, 3457],
        ['l', 754, 3457],
        ['l', 672, 2703],
        ['q', 2441, 2662, 2441, 1450],
        ['q', 2441, 1032, 2220, 651],
        ['q', 1999, 270, 1638, -16],
        ['q', 958, -549, 172, -819],
        ['l', 172, -745],
        ['l', 262, -696],
        ['q', 1040, -270, 1466, 360],
        ['q', 1786, 844, 1786, 1417],
      ],
    },
    '6': {
      xoff: 4096,
      width: 3392,
      height: 4992,
      hbx: 320,
      hby: 4928,
      path: [
        ['m', 1090, 2662],
        ['q', 1188, 2859, 1450, 3035],
        ['q', 1712, 3211, 2216, 3211],
        ['q', 2720, 3211, 3199, 2842],
        ['q', 3678, 2474, 3678, 1745],
        ['q', 3678, 1016, 3219, 491],
        ['q', 2761, -33, 1901, -33],
        ['q', 328, -33, 328, 1892],
        ['q', 328, 2793, 786, 3539],
        ['q', 1327, 4399, 2376, 4735],
        ['q', 2966, 4915, 3695, 4915],
        ['l', 3686, 4858],
        ['q', 2236, 4858, 1573, 3924],
        ['q', 1212, 3416, 1090, 2662],
        ['m', 1049, 2458],
        ['q', 975, 1950, 975, 1524],
        ['q', 975, 803, 1249, 418],
        ['q', 1524, 33, 1966, 33],
        ['q', 2408, 33, 2715, 524],
        ['q', 3023, 1016, 3023, 1749],
        ['q', 3023, 2482, 2740, 2814],
        ['q', 2458, 3146, 2056, 3146],
        ['q', 1786, 3146, 1536, 2990],
        ['q', 1286, 2834, 1167, 2674],
        ['q', 1049, 2515, 1049, 2458],
      ],
    },
    '7': {
      xoff: 3392,
      width: 2752,
      height: 4992,
      hbx: 384,
      hby: 4160,
      path: [
        ['m', 410, 4104],
        ['l', 3105, 4104],
        ['q', 1450, 205, 844, -819],
        ['l', 778, -795],
        ['q', 1425, 319, 2753, 3457],
        ['l', 410, 3465],
        ['l', 410, 4104],
      ],
    },
    '8': {
      xoff: 4416,
      width: 3520,
      height: 4992,
      hbx: 448,
      hby: 4928,
      path: [
        ['m', 3858, 3940],
        ['q', 3858, 3056, 2867, 2531],
        ['q', 3408, 2417, 3678, 2179],
        ['q', 3949, 1942, 3957, 1466],
        ['q', 3957, 1204, 3821, 913],
        ['q', 3686, 623, 3502, 434],
        ['q', 3318, 246, 2945, 106],
        ['q', 2572, -33, 2093, -33],
        ['q', 1614, -33, 1290, 90],
        ['q', 967, 213, 811, 372],
        ['q', 655, 532, 577, 765],
        ['q', 500, 999, 496, 1110],
        ['q', 492, 1221, 492, 1298],
        ['q', 492, 1376, 492, 1466],
        ['q', 549, 2277, 1769, 2826],
        ['q', 893, 3072, 893, 3801],
        ['q', 893, 4334, 1347, 4624],
        ['q', 1802, 4915, 2404, 4915],
        ['q', 3006, 4915, 3432, 4673],
        ['q', 3858, 4432, 3858, 3940],
        ['m', 1835, 2793],
        ['q', 1139, 2212, 1139, 1343],
        ['q', 1139, 999, 1221, 729],
        ['q', 1303, 459, 1413, 323],
        ['q', 1524, 188, 1696, 114],
        ['q', 1868, 41, 1929, 37],
        ['q', 1991, 33, 2159, 33],
        ['q', 2327, 33, 2527, 110],
        ['q', 2728, 188, 2855, 315],
        ['q', 2982, 442, 3076, 593],
        ['q', 3170, 745, 3211, 901],
        ['q', 3310, 1286, 3310, 1544],
        ['q', 3310, 1802, 3236, 2003],
        ['q', 3162, 2204, 2977, 2335],
        ['q', 2793, 2466, 2637, 2531],
        ['q', 2482, 2597, 2212, 2675],
        ['q', 1942, 2753, 1835, 2793],
        ['m', 2802, 2556],
        ['q', 3211, 3113, 3211, 3957],
        ['q', 3211, 4301, 3031, 4575],
        ['q', 2851, 4850, 2351, 4850],
        ['q', 1982, 4850, 1778, 4563],
        ['q', 1548, 4235, 1548, 3727],
        ['q', 1548, 3154, 1802, 2966],
        ['q', 1950, 2851, 2093, 2797],
        ['q', 2236, 2744, 2453, 2682],
        ['q', 2671, 2621, 2802, 2556],
      ],
    },
    '9': {
      xoff: 4096,
      width: 3392,
      height: 4992,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 2933, 1442],
        ['q', 2834, 1245, 2572, 1069],
        ['q', 2310, 893, 1806, 893],
        ['q', 1303, 893, 823, 1261],
        ['q', 344, 1630, 344, 2359],
        ['q', 344, 3088, 803, 3612],
        ['q', 1262, 4137, 2122, 4137],
        ['q', 3695, 4137, 3695, 2212],
        ['q', 3695, 1311, 3228, 565],
        ['q', 2695, -295, 1638, -623],
        ['q', 1057, -811, 328, -811],
        ['l', 336, -754],
        ['q', 1786, -754, 2449, 180],
        ['q', 2810, 688, 2933, 1442],
        ['m', 2974, 1647],
        ['q', 3047, 2154, 3047, 2580],
        ['q', 3047, 3301, 2773, 3686],
        ['q', 2499, 4071, 2056, 4071],
        ['q', 1614, 4071, 1306, 3579],
        ['q', 999, 3088, 999, 2355],
        ['q', 999, 1622, 1282, 1290],
        ['q', 1565, 958, 1966, 958],
        ['q', 2236, 958, 2486, 1114],
        ['q', 2736, 1270, 2855, 1429],
        ['q', 2974, 1589, 2974, 1647],
      ],
    },
    ' ': {
      xoff: 2432,
      width: 0,
      height: 0,
      hbx: 0,
      hby: 0,
      path: [],
    },
    '!': {
      xoff: 2304,
      width: 768,
      height: 5824,
      hbx: 768,
      hby: 6144,
      path: [
        ['m', 877, 6144],
        ['l', 1450, 6144],
        ['l', 1286, 1843],
        ['l', 1040, 1843],
        ['l', 877, 6144],
        ['m', 925, 430],
        ['q', 827, 532, 827, 679],
        ['q', 827, 827, 925, 925],
        ['q', 1024, 1024, 1171, 1024],
        ['q', 1319, 1024, 1421, 925],
        ['q', 1524, 827, 1524, 679],
        ['q', 1524, 532, 1421, 430],
        ['q', 1319, 328, 1171, 328],
        ['q', 1024, 328, 925, 430],
      ],
    },
    '"': {
      xoff: 2624,
      width: 1280,
      height: 1536,
      hbx: 704,
      hby: 6144,
      path: [
        ['m', 721, 6128],
        ['l', 983, 6144],
        ['l', 860, 4645],
        ['l', 754, 4645],
        ['l', 721, 6128],
        ['m', 1704, 6128],
        ['l', 1966, 6144],
        ['l', 1843, 4645],
        ['l', 1737, 4645],
        ['l', 1704, 6128],
      ],
    },
    '#': {
      xoff: 4928,
      width: 4416,
      height: 5696,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 557, 3957],
        ['l', 565, 4022],
        ['l', 1327, 4022],
        ['l', 1630, 5734],
        ['l', 2286, 5734],
        ['l', 1982, 4022],
        ['l', 2982, 4022],
        ['l', 3285, 5734],
        ['l', 3940, 5734],
        ['l', 3637, 4022],
        ['l', 4588, 4022],
        ['l', 4579, 3957],
        ['l', 3629, 3957],
        ['l', 3310, 2146],
        ['l', 4260, 2146],
        ['l', 4252, 2081],
        ['l', 3293, 2081],
        ['l', 2949, 90],
        ['l', 2294, 90],
        ['l', 2638, 2081],
        ['l', 1638, 2081],
        ['l', 1294, 90],
        ['l', 639, 90],
        ['l', 983, 2081],
        ['l', 229, 2081],
        ['l', 238, 2146],
        ['l', 999, 2146],
        ['l', 1319, 3957],
        ['l', 557, 3957],
        ['m', 1974, 3957],
        ['l', 1655, 2146],
        ['l', 2654, 2146],
        ['l', 2974, 3957],
        ['l', 1974, 3957],
      ],
    },
    $: {
      xoff: 4800,
      width: 3712,
      height: 6272,
      hbx: 576,
      hby: 5760,
      path: [
        ['m', 2523, -483],
        ['l', 2441, -483],
        ['l', 2441, -8],
        ['l', 2335, -8],
        ['q', 1327, -8, 614, 492],
        ['l', 655, 557],
        ['q', 926, 352, 1356, 213],
        ['q', 1786, 74, 2072, 74],
        ['q', 2359, 74, 2441, 82],
        ['l', 2441, 2138],
        ['q', 2163, 2228, 2077, 2261],
        ['q', 1991, 2294, 1741, 2388],
        ['q', 1491, 2482, 1397, 2547],
        ['q', 1303, 2613, 1130, 2736],
        ['q', 958, 2859, 893, 2982],
        ['q', 705, 3318, 705, 3637],
        ['q', 705, 4178, 1106, 4555],
        ['q', 1507, 4932, 2302, 4932],
        ['l', 2441, 4932],
        ['l', 2441, 5726],
        ['l', 2523, 5726],
        ['l', 2523, 4923],
        ['q', 3236, 4891, 3957, 4653],
        ['l', 3924, 4571],
        ['q', 3252, 4825, 2523, 4858],
        ['l', 2523, 2695],
        ['q', 2867, 2580, 3035, 2519],
        ['q', 3203, 2458, 3481, 2314],
        ['q', 3760, 2171, 3899, 2032],
        ['q', 4260, 1655, 4260, 1110],
        ['q', 4260, 565, 3772, 295],
        ['q', 3285, 25, 2523, 0],
        ['l', 2523, -483],
        ['m', 1532, 3113],
        ['q', 1851, 2916, 2441, 2720],
        ['l', 2441, 4858],
        ['q', 1851, 4841, 1486, 4571],
        ['q', 1122, 4301, 1122, 3834],
        ['q', 1122, 3367, 1532, 3113],
        ['m', 2523, 82],
        ['q', 3105, 123, 3473, 319],
        ['q', 3842, 516, 3842, 942],
        ['q', 3842, 1368, 3502, 1626],
        ['q', 3162, 1884, 2523, 2105],
        ['l', 2523, 82],
      ],
    },
    '%': {
      xoff: 5376,
      width: 4224,
      height: 4096,
      hbx: 512,
      hby: 4096,
      path: [
        ['m', 4014, 4096],
        ['l', 4096, 4096],
        ['l', 1229, 0],
        ['l', 1147, 0],
        ['l', 4014, 4096],
        ['m', 573, 3277],
        ['q', 573, 3613, 884, 3854],
        ['q', 1196, 4096, 1638, 4096],
        ['q', 2703, 4096, 2703, 3277],
        ['q', 2703, 2941, 2388, 2699],
        ['q', 2073, 2458, 1638, 2458],
        ['q', 573, 2458, 573, 3277],
        ['m', 1642, 4030],
        ['q', 1401, 4030, 1233, 3809],
        ['q', 1065, 3588, 1065, 3248],
        ['q', 1065, 2908, 1224, 2715],
        ['q', 1384, 2523, 1630, 2523],
        ['q', 1876, 2523, 2044, 2744],
        ['q', 2212, 2966, 2212, 3305],
        ['q', 2212, 3645, 2048, 3837],
        ['q', 1884, 4030, 1642, 4030],
        ['m', 2580, 819],
        ['q', 2580, 1155, 2891, 1396],
        ['q', 3203, 1638, 3645, 1638],
        ['q', 4710, 1638, 4710, 819],
        ['q', 4710, 483, 4395, 241],
        ['q', 4080, 0, 3645, 0],
        ['q', 2580, 0, 2580, 819],
        ['m', 3649, 1573],
        ['q', 3408, 1573, 3240, 1351],
        ['q', 3072, 1130, 3072, 790],
        ['q', 3072, 451, 3231, 258],
        ['q', 3391, 66, 3637, 66],
        ['q', 3883, 66, 4051, 287],
        ['q', 4219, 508, 4219, 848],
        ['q', 4219, 1188, 4055, 1380],
        ['q', 3891, 1573, 3649, 1573],
      ],
    },
    '&': {
      xoff: 7360,
      width: 6976,
      height: 4608,
      hbx: 128,
      hby: 4608,
      path: [
        ['m', 5038, 3211],
        ['l', 5038, 3293],
        ['l', 7062, 3293],
        ['l', 7062, 3211],
        ['l', 6611, 3211],
        ['q', 6169, 2007, 5145, 1049],
        ['q', 4645, 582, 3973, 291],
        ['q', 3301, 0, 2589, 0],
        ['q', 1909, 0, 1343, 262],
        ['q', 1016, 410, 766, 643],
        ['q', 516, 877, 352, 1274],
        ['q', 188, 1671, 188, 2187],
        ['q', 188, 3195, 806, 3887],
        ['q', 1425, 4579, 2212, 4579],
        ['q', 3637, 4579, 3686, 3310],
        ['l', 5046, 4383],
        ['l', 5104, 4334],
        ['l', 1040, 1139],
        ['q', 1245, 647, 1626, 364],
        ['q', 2007, 82, 2584, 82],
        ['q', 3162, 82, 3739, 373],
        ['q', 4317, 664, 4743, 1130],
        ['q', 5603, 2081, 5956, 3211],
        ['l', 5038, 3211],
        ['m', 3039, 2793],
        ['q', 3031, 3727, 2855, 4112],
        ['q', 2679, 4497, 2265, 4497],
        ['q', 1851, 4497, 1568, 4280],
        ['q', 1286, 4063, 1130, 3711],
        ['q', 844, 3031, 844, 2228],
        ['l', 860, 1868],
        ['q', 901, 1499, 1008, 1196],
        ['l', 3039, 2793],
      ],
    },
    "'": {
      xoff: 832,
      width: 320,
      height: 1536,
      hbx: 192,
      hby: 6144,
      path: [
        ['m', 229, 6128],
        ['l', 492, 6144],
        ['l', 369, 4645],
        ['l', 262, 4645],
        ['l', 229, 6128],
      ],
    },
    '(': {
      xoff: 2432,
      width: 1600,
      height: 7808,
      hbx: 512,
      hby: 6144,
      path: [
        ['m', 1221, 1933],
        ['q', 1221, -926, 2040, -1581],
        ['l', 2007, -1638],
        ['q', 1622, -1491, 1352, -1163],
        ['q', 1221, -1008, 1049, -688],
        ['q', 565, 238, 565, 1966],
        ['q', 565, 2867, 675, 3547],
        ['q', 786, 4227, 917, 4604],
        ['q', 1049, 4981, 1200, 5276],
        ['q', 1352, 5571, 1499, 5726],
        ['q', 1810, 6054, 1966, 6111],
        ['l', 2040, 6144],
        ['l', 2089, 6038],
        ['q', 2056, 6021, 2003, 5976],
        ['q', 1950, 5931, 1806, 5693],
        ['q', 1663, 5456, 1552, 5095],
        ['q', 1442, 4735, 1343, 4014],
        ['q', 1221, 3146, 1221, 1933],
      ],
    },
    ')': {
      xoff: 2432,
      width: 1600,
      height: 7808,
      hbx: 256,
      hby: 6144,
      path: [
        ['m', 839, 5788],
        ['q', 1081, 5538, 1269, 5169],
        ['q', 1458, 4801, 1646, 3977],
        ['q', 1835, 3154, 1835, 1819],
        ['q', 1835, 1475, 1782, 946],
        ['q', 1729, 418, 1622, 24],
        ['q', 1516, -369, 1348, -688],
        ['q', 1180, -1008, 1049, -1167],
        ['q', 918, -1327, 737, -1450],
        ['q', 565, -1573, 393, -1638],
        ['l', 360, -1581],
        ['q', 1180, -926, 1180, 1933],
        ['q', 1180, 3146, 1073, 3940],
        ['q', 967, 4735, 844, 5095],
        ['q', 598, 5841, 393, 5980],
        ['l', 311, 6038],
        ['l', 360, 6144],
        ['q', 418, 6128, 508, 6083],
        ['q', 598, 6038, 839, 5788],
      ],
    },
    '*': {
      xoff: 4544,
      width: 2944,
      height: 2944,
      hbx: 832,
      hby: 5760,
      path: [
        ['m', 2318, 2851],
        ['l', 2253, 2851],
        ['l', 2253, 4219],
        ['l', 1286, 3252],
        ['l', 1245, 3293],
        ['l', 2212, 4260],
        ['l', 844, 4260],
        ['l', 844, 4325],
        ['l', 2212, 4325],
        ['l', 1245, 5292],
        ['l', 1286, 5333],
        ['l', 2253, 4366],
        ['l', 2253, 5734],
        ['l', 2318, 5734],
        ['l', 2318, 4366],
        ['l', 3285, 5333],
        ['l', 3326, 5292],
        ['l', 2359, 4325],
        ['l', 3727, 4325],
        ['l', 3727, 4260],
        ['l', 2359, 4260],
        ['l', 3326, 3293],
        ['l', 3285, 3252],
        ['l', 2318, 4219],
        ['l', 2318, 2851],
      ],
    },
    '+': {
      xoff: 5376,
      width: 3520,
      height: 3456,
      hbx: 832,
      hby: 3776,
      path: [
        ['m', 868, 2171],
        ['l', 2220, 2171],
        ['l', 2220, 3768],
        ['l', 2875, 3768],
        ['l', 2875, 2171],
        ['l', 4309, 2171],
        ['l', 4309, 2105],
        ['l', 2875, 2105],
        ['l', 2875, 328],
        ['l', 2220, 328],
        ['l', 2220, 2105],
        ['l', 868, 2105],
        ['l', 868, 2171],
      ],
    },
    ',': {
      xoff: 768,
      width: 512,
      height: 1536,
      hbx: 64,
      hby: 704,
      path: [
        ['m', 311, 664],
        ['l', 573, 680],
        ['l', 205, -819],
        ['l', 98, -819],
        ['l', 311, 664],
      ],
    },
    '-': {
      xoff: 3264,
      width: 2560,
      height: 128,
      hbx: 320,
      hby: 2432,
      path: [
        ['m', 377, 2400],
        ['l', 2851, 2400],
        ['l', 2851, 2335],
        ['l', 377, 2335],
        ['l', 377, 2400],
      ],
    },
    '.': {
      xoff: 896,
      width: 576,
      height: 576,
      hbx: 192,
      hby: 512,
      path: [
        ['m', 491, -33],
        ['q', 385, -33, 307, 45],
        ['q', 229, 123, 229, 233],
        ['q', 229, 344, 303, 418],
        ['q', 377, 492, 487, 492],
        ['q', 598, 492, 676, 414],
        ['q', 754, 336, 754, 229],
        ['q', 754, 123, 676, 45],
        ['q', 598, -33, 491, -33],
      ],
    },
    '/': {
      xoff: 4032,
      width: 2240,
      height: 6144,
      hbx: 768,
      hby: 6144,
      path: [
        ['m', 901, 0],
        ['l', 819, 0],
        ['l', 2875, 6136],
        ['l', 2957, 6136],
        ['l', 901, 0],
      ],
    },
    ':': {
      xoff: 2048,
      width: 576,
      height: 3968,
      hbx: 640,
      hby: 3904,
      path: [
        ['m', 942, -33],
        ['q', 836, -33, 758, 45],
        ['q', 680, 123, 680, 233],
        ['q', 680, 344, 758, 418],
        ['q', 836, 492, 942, 492],
        ['q', 1049, 492, 1126, 414],
        ['q', 1204, 336, 1204, 229],
        ['q', 1204, 123, 1126, 45],
        ['q', 1049, -33, 942, -33],
        ['m', 758, 3395],
        ['q', 680, 3473, 680, 3579],
        ['q', 680, 3686, 758, 3764],
        ['q', 836, 3842, 942, 3842],
        ['q', 1049, 3842, 1126, 3764],
        ['q', 1204, 3686, 1204, 3579],
        ['q', 1204, 3473, 1126, 3395],
        ['q', 1049, 3318, 942, 3318],
        ['q', 836, 3318, 758, 3395],
      ],
    },
    ';': {
      xoff: 2048,
      width: 640,
      height: 4736,
      hbx: 576,
      hby: 3904,
      path: [
        ['m', 758, 3395],
        ['q', 680, 3473, 680, 3579],
        ['q', 680, 3686, 758, 3764],
        ['q', 836, 3842, 942, 3842],
        ['q', 1049, 3842, 1126, 3764],
        ['q', 1204, 3686, 1204, 3579],
        ['q', 1204, 3473, 1126, 3395],
        ['q', 1049, 3318, 942, 3318],
        ['q', 836, 3318, 758, 3395],
        ['m', 803, 664],
        ['l', 1065, 680],
        ['l', 696, -819],
        ['l', 590, -819],
        ['l', 803, 664],
      ],
    },
    '<': {
      xoff: 4672,
      width: 3008,
      height: 3328,
      hbx: 768,
      hby: 4096,
      path: [
        ['m', 819, 2458],
        ['l', 3703, 4096],
        ['l', 3760, 4039],
        ['l', 1360, 2449],
        ['l', 3760, 885],
        ['l', 3703, 819],
        ['l', 819, 2458],
      ],
    },
    '=': {
      xoff: 6080,
      width: 3776,
      height: 1920,
      hbx: 1152,
      hby: 2944,
      path: [
        ['m', 1196, 2933],
        ['l', 4915, 2933],
        ['l', 4915, 2867],
        ['l', 1196, 2867],
        ['l', 1196, 2933],
        ['m', 1196, 1114],
        ['l', 4915, 1114],
        ['l', 4915, 1049],
        ['l', 1196, 1049],
        ['l', 1196, 1114],
      ],
    },
    '>': {
      xoff: 4672,
      width: 3008,
      height: 3328,
      hbx: 768,
      hby: 4096,
      path: [
        ['m', 877, 4096],
        ['l', 3760, 2458],
        ['l', 877, 819],
        ['l', 819, 885],
        ['l', 3219, 2449],
        ['l', 819, 4039],
        ['l', 877, 4096],
      ],
    },
    '?': {
      xoff: 3520,
      width: 2944,
      height: 5888,
      hbx: 256,
      hby: 5824,
      path: [
        ['m', 295, 5571],
        ['q', 958, 5775, 1626, 5775],
        ['q', 2294, 5775, 2720, 5443],
        ['q', 3146, 5112, 3146, 4448],
        ['q', 3146, 3801, 2408, 3113],
        ['q', 2097, 2834, 1790, 2539],
        ['q', 1483, 2245, 1266, 1860],
        ['q', 1049, 1475, 1049, 1049],
        ['l', 967, 1049],
        ['q', 967, 1835, 1507, 2572],
        ['q', 1729, 2875, 1950, 3162],
        ['q', 2499, 3858, 2499, 4436],
        ['q', 2499, 5014, 2228, 5362],
        ['q', 1958, 5710, 1458, 5710],
        ['q', 1081, 5710, 524, 5571],
        ['l', 328, 5521],
        ['l', 295, 5571],
        ['m', 762, 233],
        ['q', 762, 344, 840, 418],
        ['q', 918, 492, 1024, 492],
        ['q', 1130, 492, 1208, 414],
        ['q', 1286, 336, 1286, 229],
        ['q', 1286, 123, 1208, 45],
        ['q', 1130, -33, 1024, -33],
        ['q', 918, -33, 840, 45],
        ['q', 762, 123, 762, 233],
      ],
    },
    '@': {
      xoff: 8768,
      width: 7424,
      height: 7424,
      hbx: 640,
      hby: 5760,
      path: [
        ['m', 8012, 2048],
        ['q', 8012, 1524, 7885, 1139],
        ['q', 7758, 754, 7577, 541],
        ['q', 7397, 328, 7127, 201],
        ['q', 6857, 74, 6644, 41],
        ['q', 6431, 8, 6160, 4],
        ['q', 5890, 0, 5689, 61],
        ['q', 5489, 123, 5407, 213],
        ['q', 5235, 377, 5235, 524],
        ['l', 5235, 696],
        ['q', 5087, 410, 4776, 188],
        ['q', 4465, -33, 4030, -33],
        ['q', 2875, -33, 2777, 901],
        ['q', 2769, 999, 2769, 1097],
        ['q', 2769, 1196, 2793, 1310],
        ['q', 2818, 1425, 2966, 1581],
        ['q', 3236, 1876, 4350, 1958],
        ['q', 4612, 1982, 4833, 1982],
        ['q', 5054, 1982, 5235, 1966],
        ['l', 5235, 3408],
        ['q', 5235, 3457, 5194, 3584],
        ['q', 5153, 3711, 5083, 3809],
        ['q', 5014, 3908, 4850, 3985],
        ['q', 4686, 4063, 4465, 4063],
        ['q', 3662, 4063, 3031, 3736],
        ['l', 2998, 3793],
        ['q', 3105, 3842, 3166, 3870],
        ['q', 3228, 3899, 3322, 3936],
        ['q', 3416, 3973, 3539, 4006],
        ['q', 3662, 4039, 3801, 4063],
        ['q', 4096, 4129, 4465, 4129],
        ['q', 5808, 4129, 5808, 3326],
        ['l', 5808, 582],
        ['q', 5808, 246, 5980, 131],
        ['q', 6062, 82, 6119, 82],
        ['l', 6177, 82],
        ['q', 6554, 82, 6914, 459],
        ['q', 7111, 664, 7233, 1073],
        ['q', 7356, 1483, 7356, 2048],
        ['q', 7356, 2998, 7122, 3711],
        ['q', 6889, 4424, 6472, 4841],
        ['q', 5636, 5669, 4362, 5669],
        ['q', 3088, 5669, 2199, 4608],
        ['q', 1311, 3547, 1311, 2048],
        ['q', 1311, 1090, 1544, 373],
        ['q', 1778, -344, 2199, -757],
        ['q', 2621, -1171, 3153, -1372],
        ['q', 3686, -1573, 4333, -1573],
        ['q', 4981, -1573, 5710, -1253],
        ['l', 5759, -1303],
        ['q', 5546, -1425, 5148, -1531],
        ['q', 4751, -1638, 4334, -1638],
        ['q', 2736, -1638, 1737, -819],
        ['q', 1221, -401, 938, 328],
        ['q', 655, 1057, 655, 2048],
        ['q', 655, 3572, 1732, 4653],
        ['q', 2810, 5734, 4334, 5734],
        ['q', 5923, 5734, 6930, 4882],
        ['q', 7447, 4456, 7729, 3735],
        ['q', 8012, 3015, 8012, 2048],
        ['m', 4039, 33],
        ['q', 4514, 33, 4862, 328],
        ['q', 5210, 623, 5235, 909],
        ['l', 5235, 1901],
        ['q', 5014, 1917, 4788, 1917],
        ['q', 4563, 1917, 4342, 1892],
        ['q', 3711, 1819, 3526, 1614],
        ['q', 3342, 1409, 3342, 1073],
        ['q', 3342, 991, 3351, 901],
        ['q', 3449, 33, 4039, 33],
      ],
    },
    A: {
      xoff: 5120,
      width: 4672,
      height: 5824,
      hbx: 192,
      hby: 5824,
      path: [
        ['m', 344, 0],
        ['l', 246, 0],
        ['l', 2695, 5734],
        ['l', 2785, 5775],
        ['l', 4850, 0],
        ['l', 4153, 0],
        ['l', 3514, 1802],
        ['l', 1122, 1802],
        ['l', 344, 0],
        ['m', 2441, 4850],
        ['l', 1155, 1884],
        ['l', 3490, 1884],
        ['l', 2441, 4850],
      ],
    },
    B: {
      xoff: 4672,
      width: 3904,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 573, 5669],
        ['q', 1524, 5734, 2253, 5734],
        ['q', 4276, 5734, 4276, 4383],
        ['q', 4276, 3875, 3981, 3510],
        ['q', 3686, 3146, 3039, 3015],
        ['q', 3662, 2941, 4022, 2638],
        ['q', 4383, 2335, 4383, 1581],
        ['q', 4383, 0, 2359, 0],
        ['l', 573, 0],
        ['l', 573, 5669],
        ['m', 1253, 82],
        ['l', 2359, 82],
        ['q', 3088, 82, 3395, 463],
        ['q', 3703, 844, 3703, 1630],
        ['q', 3703, 2417, 3391, 2679],
        ['q', 3080, 2941, 2466, 2957],
        ['l', 1253, 2957],
        ['l', 1253, 82],
        ['m', 2253, 5652],
        ['q', 1778, 5652, 1253, 5595],
        ['l', 1253, 3039],
        ['l', 2466, 3039],
        ['q', 3621, 3088, 3621, 4366],
        ['q', 3621, 4989, 3277, 5320],
        ['q', 2933, 5652, 2253, 5652],
      ],
    },
    C: {
      xoff: 5056,
      width: 4416,
      height: 5824,
      hbx: 384,
      hby: 5760,
      path: [
        ['m', 3269, -33],
        ['q', 1737, -33, 999, 836],
        ['q', 737, 1147, 573, 1663],
        ['q', 410, 2179, 410, 2916],
        ['q', 410, 3654, 651, 4239],
        ['q', 893, 4825, 1311, 5145],
        ['q', 2122, 5743, 3269, 5743],
        ['q', 3596, 5743, 3907, 5689],
        ['q', 4219, 5636, 4375, 5579],
        ['l', 4522, 5521],
        ['l', 4497, 5439],
        ['q', 3940, 5661, 3269, 5661],
        ['q', 2400, 5661, 1819, 5095],
        ['q', 1376, 4678, 1196, 3867],
        ['q', 1090, 3408, 1090, 2744],
        ['q', 1090, 2081, 1278, 1519],
        ['q', 1466, 958, 1708, 688],
        ['q', 1950, 418, 2294, 258],
        ['q', 2638, 98, 2842, 73],
        ['q', 3047, 49, 3338, 49],
        ['q', 3629, 49, 3997, 106],
        ['q', 4366, 164, 4555, 213],
        ['l', 4743, 270],
        ['l', 4768, 188],
        ['q', 4145, -33, 3269, -33],
      ],
    },
    D: {
      xoff: 5120,
      width: 4224,
      height: 5824,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 1229, 5726],
        ['q', 1589, 5743, 1937, 5743],
        ['q', 2286, 5743, 2675, 5669],
        ['q', 3064, 5595, 3445, 5394],
        ['q', 3826, 5194, 4092, 4878],
        ['q', 4358, 4563, 4522, 4047],
        ['q', 4686, 3531, 4686, 2793],
        ['q', 4686, 2056, 4444, 1470],
        ['q', 4202, 885, 3785, 573],
        ['q', 2974, -33, 1827, -33],
        ['q', 1425, -33, 983, 0],
        ['l', 573, 0],
        ['l', 573, 5726],
        ['l', 1229, 5726],
        ['m', 1253, 66],
        ['q', 1425, 49, 1687, 49],
        ['q', 1950, 49, 2081, 57],
        ['q', 2212, 66, 2441, 127],
        ['q', 2671, 188, 2867, 294],
        ['q', 3064, 401, 3281, 610],
        ['q', 3498, 819, 3654, 1106],
        ['q', 4006, 1778, 4006, 2859],
        ['q', 4006, 3629, 3817, 4190],
        ['q', 3629, 4751, 3387, 5021],
        ['q', 3146, 5292, 2802, 5452],
        ['q', 2458, 5612, 2253, 5636],
        ['q', 2048, 5661, 1777, 5661],
        ['q', 1507, 5661, 1253, 5636],
        ['l', 1253, 66],
      ],
    },
    E: {
      xoff: 4288,
      width: 3520,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 3834, 5734],
        ['l', 3834, 5652],
        ['l', 1253, 5652],
        ['l', 1253, 3195],
        ['l', 3645, 3195],
        ['l', 3645, 3113],
        ['l', 1253, 3113],
        ['l', 1253, 82],
        ['l', 4014, 82],
        ['l', 4014, 0],
        ['l', 573, 0],
        ['l', 573, 5734],
        ['l', 3834, 5734],
      ],
    },
    F: {
      xoff: 4096,
      width: 3328,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 3834, 5734],
        ['l', 3834, 5652],
        ['l', 1253, 5652],
        ['l', 1253, 3031],
        ['l', 3645, 3031],
        ['l', 3645, 2949],
        ['l', 1253, 2949],
        ['l', 1253, 0],
        ['l', 573, 0],
        ['l', 573, 5734],
        ['l', 3834, 5734],
      ],
    },
    G: {
      xoff: 5312,
      width: 4736,
      height: 5824,
      hbx: 384,
      hby: 5760,
      path: [
        ['m', 3269, -33],
        ['q', 1737, -33, 999, 836],
        ['q', 737, 1147, 573, 1663],
        ['q', 410, 2179, 410, 2916],
        ['q', 410, 3654, 651, 4239],
        ['q', 893, 4825, 1311, 5145],
        ['q', 2122, 5743, 3269, 5743],
        ['q', 3637, 5743, 3989, 5689],
        ['q', 4342, 5636, 4514, 5579],
        ['l', 4686, 5521],
        ['l', 4661, 5439],
        ['q', 4022, 5661, 3269, 5661],
        ['q', 2400, 5661, 1819, 5095],
        ['q', 1376, 4678, 1196, 3867],
        ['q', 1090, 3408, 1090, 2744],
        ['q', 1090, 2081, 1278, 1519],
        ['q', 1466, 958, 1708, 688],
        ['q', 1950, 418, 2294, 258],
        ['q', 2638, 98, 2842, 73],
        ['q', 3047, 49, 3330, 49],
        ['q', 3613, 49, 4088, 115],
        ['l', 4088, 1802],
        ['l', 3097, 1802],
        ['l', 3097, 1884],
        ['l', 5120, 1884],
        ['l', 5120, 1802],
        ['l', 4768, 1802],
        ['l', 4768, 188],
        ['q', 4145, -33, 3269, -33],
      ],
    },
    H: {
      xoff: 4864,
      width: 4096,
      height: 5760,
      hbx: 384,
      hby: 5760,
      path: [
        ['m', 1090, 0],
        ['l', 410, 0],
        ['l', 410, 5734],
        ['l', 1090, 5734],
        ['l', 1090, 3097],
        ['l', 3752, 3097],
        ['l', 3752, 5734],
        ['l', 4432, 5734],
        ['l', 4432, 0],
        ['l', 3752, 0],
        ['l', 3752, 3015],
        ['l', 1090, 3015],
        ['l', 1090, 0],
      ],
    },
    I: {
      xoff: 2624,
      width: 1536,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 573, 5652],
        ['l', 573, 5734],
        ['l', 2032, 5734],
        ['l', 2032, 5652],
        ['l', 1630, 5652],
        ['l', 1630, 82],
        ['l', 2032, 82],
        ['l', 2032, 0],
        ['l', 573, 0],
        ['l', 573, 82],
        ['l', 950, 82],
        ['l', 950, 5652],
        ['l', 573, 5652],
      ],
    },
    J: {
      xoff: 2432,
      width: 2048,
      height: 5760,
      hbx: -192,
      hby: 5760,
      path: [
        ['m', 369, 5652],
        ['l', 369, 5734],
        ['l', 1827, 5734],
        ['l', 1827, 1081],
        ['q', 1827, 434, 1565, 217],
        ['q', 1303, 0, 774, 0],
        ['q', 246, 0, -164, 156],
        ['l', -139, 221],
        ['q', 254, 66, 672, 66],
        ['q', 950, 66, 1044, 303],
        ['q', 1139, 541, 1139, 1073],
        ['l', 1139, 5652],
        ['l', 369, 5652],
      ],
    },
    K: {
      xoff: 4928,
      width: 4224,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 1253, 5734],
        ['l', 1253, 2114],
        ['l', 3899, 5734],
        ['l', 3965, 5677],
        ['l', 2499, 3678],
        ['l', 4678, 0],
        ['l', 3916, 0],
        ['l', 2081, 3105],
        ['l', 1253, 1966],
        ['l', 1253, 0],
        ['l', 573, 0],
        ['l', 573, 5734],
        ['l', 1253, 5734],
      ],
    },
    L: {
      xoff: 3904,
      width: 3200,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 3686, 0],
        ['l', 573, 0],
        ['l', 573, 5734],
        ['l', 1253, 5734],
        ['l', 1253, 82],
        ['l', 3686, 82],
        ['l', 3686, 0],
      ],
    },
    M: {
      xoff: 6528,
      width: 5440,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 639, 0],
        ['l', 532, 0],
        ['l', 1245, 5734],
        ['l', 1516, 5734],
        ['l', 3236, 434],
        ['l', 4948, 5734],
        ['l', 5218, 5734],
        ['l', 5931, 0],
        ['l', 5251, 0],
        ['l', 4686, 4588],
        ['l', 3203, 0],
        ['l', 2687, 0],
        ['l', 1188, 4530],
        ['l', 639, 0],
      ],
    },
    N: {
      xoff: 4864,
      width: 3840,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 639, 0],
        ['l', 532, 0],
        ['l', 532, 5734],
        ['l', 811, 5734],
        ['l', 4219, 434],
        ['l', 4219, 5734],
        ['l', 4325, 5734],
        ['l', 4325, 0],
        ['l', 3727, 0],
        ['l', 639, 4751],
        ['l', 639, 0],
      ],
    },
    O: {
      xoff: 5888,
      width: 5120,
      height: 5888,
      hbx: 384,
      hby: 5824,
      path: [
        ['m', 410, 2728],
        ['q', 410, 4219, 1135, 4993],
        ['q', 1860, 5767, 2998, 5767],
        ['q', 4137, 5767, 4813, 5095],
        ['q', 5489, 4424, 5489, 2949],
        ['q', 5489, 1475, 4768, 721],
        ['q', 4047, -33, 2843, -33],
        ['q', 1802, -33, 1139, 565],
        ['q', 795, 877, 602, 1429],
        ['q', 410, 1982, 410, 2728],
        ['m', 2973, 5685],
        ['q', 2146, 5685, 1618, 4948],
        ['q', 1090, 4211, 1090, 2785],
        ['q', 1090, 1360, 1589, 704],
        ['q', 2089, 49, 2920, 49],
        ['q', 3752, 49, 4280, 790],
        ['q', 4809, 1532, 4809, 2945],
        ['q', 4809, 4358, 4305, 5021],
        ['q', 3801, 5685, 2973, 5685],
      ],
    },
    P: {
      xoff: 4672,
      width: 3776,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 573, 5669],
        ['q', 1524, 5734, 2245, 5734],
        ['q', 4276, 5734, 4276, 4301],
        ['q', 4276, 3637, 3932, 3138],
        ['q', 3752, 2867, 3375, 2707],
        ['q', 2998, 2548, 2466, 2548],
        ['l', 1253, 2548],
        ['l', 1253, 0],
        ['l', 573, 0],
        ['l', 573, 5669],
        ['m', 2253, 5652],
        ['q', 1778, 5652, 1253, 5595],
        ['l', 1253, 2630],
        ['l', 2466, 2630],
        ['q', 3621, 2679, 3621, 4284],
        ['q', 3621, 4940, 3277, 5296],
        ['q', 2933, 5652, 2253, 5652],
      ],
    },
    Q: {
      xoff: 5888,
      width: 6656,
      height: 7552,
      hbx: 384,
      hby: 5824,
      path: [
        ['m', 410, 2851],
        ['q', 410, 4186, 1130, 4976],
        ['q', 1851, 5767, 2949, 5767],
        ['q', 4080, 5767, 4751, 5177],
        ['q', 5489, 4514, 5489, 2851],
        ['q', 5489, 1655, 4903, 901],
        ['q', 4317, 147, 3375, 0],
        ['q', 3891, -115, 4620, -688],
        ['q', 4899, -909, 5226, -1130],
        ['q', 5964, -1622, 7021, -1622],
        ['l', 7021, -1704],
        ['q', 5530, -1704, 4702, -1376],
        ['q', 4006, -1090, 3695, -688],
        ['q', 3555, -508, 3444, -364],
        ['q', 3334, -221, 3219, -127],
        ['q', 3105, -33, 2949, -33],
        ['q', 2376, -33, 1941, 98],
        ['q', 1507, 229, 1147, 541],
        ['q', 410, 1188, 410, 2851],
        ['m', 1090, 2867],
        ['q', 1090, 49, 2949, 49],
        ['q', 3752, 49, 4280, 802],
        ['q', 4809, 1556, 4809, 2867],
        ['q', 4809, 5685, 2949, 5685],
        ['q', 2146, 5685, 1618, 4931],
        ['q', 1090, 4178, 1090, 2867],
      ],
    },
    R: {
      xoff: 4928,
      width: 4224,
      height: 5760,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 573, 5669],
        ['q', 1524, 5734, 2253, 5734],
        ['q', 4276, 5734, 4276, 4383],
        ['q', 4276, 3809, 3997, 3358],
        ['q', 3719, 2908, 3039, 2761],
        ['l', 4678, 0],
        ['l', 3916, 0],
        ['l', 2310, 2712],
        ['l', 1253, 2712],
        ['l', 1253, 0],
        ['l', 573, 0],
        ['l', 573, 5669],
        ['m', 2253, 5652],
        ['q', 1778, 5652, 1253, 5595],
        ['l', 1253, 2793],
        ['l', 2466, 2793],
        ['q', 3621, 2843, 3621, 4366],
        ['q', 3621, 4989, 3277, 5320],
        ['q', 2933, 5652, 2253, 5652],
      ],
    },
    S: {
      xoff: 4224,
      width: 3712,
      height: 5824,
      hbx: 256,
      hby: 5760,
      path: [
        ['m', 3596, 5390],
        ['q', 2851, 5677, 2191, 5677],
        ['q', 1532, 5677, 1163, 5398],
        ['q', 795, 5120, 795, 4628],
        ['q', 795, 4030, 1417, 3703],
        ['q', 1696, 3564, 2027, 3445],
        ['q', 2359, 3326, 2695, 3178],
        ['q', 3031, 3031, 3309, 2842],
        ['q', 3588, 2654, 3760, 2322],
        ['q', 3932, 1991, 3932, 1479],
        ['q', 3932, 967, 3645, 606],
        ['q', 3359, 246, 2953, 119],
        ['q', 2548, -8, 2007, -8],
        ['q', 999, -8, 287, 492],
        ['l', 328, 557],
        ['q', 598, 344, 1028, 209],
        ['q', 1458, 74, 1909, 74],
        ['q', 2572, 74, 3043, 381],
        ['q', 3514, 688, 3514, 1286],
        ['q', 3514, 1942, 2892, 2310],
        ['q', 2613, 2474, 2281, 2613],
        ['q', 1950, 2753, 1614, 2904],
        ['q', 1278, 3056, 999, 3244],
        ['q', 377, 3654, 377, 4407],
        ['q', 377, 5005, 778, 5378],
        ['q', 1180, 5751, 1986, 5751],
        ['q', 2793, 5751, 3629, 5472],
        ['l', 3596, 5390],
      ],
    },
    T: {
      xoff: 4032,
      width: 3584,
      height: 5760,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 2343, 0],
        ['l', 1663, 0],
        ['l', 1663, 5652],
        ['l', 246, 5652],
        ['l', 246, 5734],
        ['l', 3768, 5734],
        ['l', 3768, 5652],
        ['l', 2343, 5652],
        ['l', 2343, 0],
      ],
    },
    U: {
      xoff: 5184,
      width: 4160,
      height: 5824,
      hbx: 512,
      hby: 5760,
      path: [
        ['m', 4514, 5734],
        ['l', 4620, 5734],
        ['l', 4620, 2458],
        ['q', 4620, 1171, 4112, 569],
        ['q', 3604, -33, 2785, -33],
        ['q', 2269, -33, 1908, 61],
        ['q', 1548, 156, 1229, 410],
        ['q', 573, 918, 573, 2458],
        ['l', 573, 5734],
        ['l', 1253, 5734],
        ['l', 1253, 2466],
        ['q', 1253, 975, 1704, 475],
        ['q', 1933, 229, 2183, 139],
        ['q', 2433, 49, 2785, 49],
        ['q', 3572, 49, 4043, 626],
        ['q', 4514, 1204, 4514, 2466],
        ['l', 4514, 5734],
      ],
    },
    V: {
      xoff: 4864,
      width: 4416,
      height: 5824,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 4432, 5734],
        ['q', 4588, 5579, 4588, 5333],
        ['q', 4588, 5128, 4497, 4915],
        ['l', 2400, 0],
        ['l', 2310, -41],
        ['l', 246, 5734],
        ['l', 942, 5734],
        ['l', 2654, 885],
        ['l', 4399, 4915],
        ['q', 4489, 5120, 4489, 5341],
        ['q', 4489, 5562, 4366, 5685],
        ['l', 4432, 5734],
      ],
    },
    W: {
      xoff: 6912,
      width: 6528,
      height: 5824,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 6529, 5734],
        ['q', 6685, 5579, 6685, 5333],
        ['q', 6685, 5128, 6595, 4915],
        ['l', 4661, 0],
        ['l', 4571, -41],
        ['l', 3490, 3391],
        ['l', 2154, 0],
        ['l', 2064, -41],
        ['l', 246, 5734],
        ['l', 942, 5734],
        ['l', 2408, 885],
        ['l', 3449, 3523],
        ['l', 2753, 5734],
        ['l', 3449, 5734],
        ['l', 4915, 885],
        ['l', 6496, 4915],
        ['q', 6586, 5120, 6586, 5341],
        ['q', 6586, 5562, 6463, 5685],
        ['l', 6529, 5734],
      ],
    },
    X: {
      xoff: 4544,
      width: 4096,
      height: 5760,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 492, 0],
        ['l', 385, 0],
        ['l', 1868, 2933],
        ['l', 246, 5734],
        ['l', 934, 5734],
        ['l', 2343, 3310],
        ['l', 3572, 5734],
        ['l', 3670, 5734],
        ['l', 2400, 3211],
        ['l', 4268, 0],
        ['l', 3580, 0],
        ['l', 1925, 2843],
        ['l', 492, 0],
      ],
    },
    Y: {
      xoff: 4352,
      width: 3968,
      height: 5760,
      hbx: 192,
      hby: 5760,
      path: [
        ['m', 3965, 5734],
        ['q', 4121, 5579, 4121, 5333],
        ['q', 4121, 5128, 4030, 4915],
        ['l', 2564, 1942],
        ['l', 2564, 0],
        ['l', 1884, 0],
        ['l', 1884, 1761],
        ['l', 246, 5734],
        ['l', 942, 5734],
        ['l', 2507, 2040],
        ['l', 3932, 4915],
        ['q', 4022, 5120, 4022, 5341],
        ['q', 4022, 5562, 3899, 5685],
        ['l', 3965, 5734],
      ],
    },
    Z: {
      xoff: 4480,
      width: 3968,
      height: 5760,
      hbx: 256,
      hby: 5760,
      path: [
        ['m', 500, 5652],
        ['l', 500, 5734],
        ['l', 3842, 5734],
        ['l', 3842, 5652],
        ['l', 950, 82],
        ['l', 3416, 82],
        ['q', 3654, 82, 3850, 164],
        ['q', 4047, 246, 4112, 401],
        ['l', 4178, 369],
        ['q', 4162, 328, 4125, 266],
        ['q', 4088, 205, 3899, 102],
        ['q', 3711, 0, 3441, 0],
        ['l', 287, 0],
        ['l', 287, 82],
        ['l', 3162, 5652],
        ['l', 500, 5652],
      ],
    },
    '[': {
      xoff: 3520,
      width: 1792,
      height: 7808,
      hbx: 704,
      hby: 6144,
      path: [
        ['m', 713, -1638],
        ['l', 713, 6144],
        ['l', 2458, 6144],
        ['l', 2458, 6078],
        ['l', 1368, 6078],
        ['l', 1368, -1573],
        ['l', 2458, -1573],
        ['l', 2458, -1638],
        ['l', 713, -1638],
      ],
    },
    '\\': {
      xoff: 4928,
      width: 2176,
      height: 6144,
      hbx: 1088,
      hby: 6144,
      path: [
        ['m', 3260, 0],
        ['l', 3178, 0],
        ['l', 1122, 6136],
        ['l', 1204, 6136],
        ['l', 3260, 0],
      ],
    },
    ']': {
      xoff: 3520,
      width: 1792,
      height: 7808,
      hbx: 1088,
      hby: 6144,
      path: [
        ['m', 1122, 6144],
        ['l', 2867, 6144],
        ['l', 2867, -1638],
        ['l', 1122, -1638],
        ['l', 1122, -1573],
        ['l', 2212, -1573],
        ['l', 2212, 6078],
        ['l', 1122, 6078],
        ['l', 1122, 6144],
      ],
    },
    '^': {
      xoff: 4608,
      width: 2240,
      height: 1344,
      hbx: 1152,
      hby: 3712,
      path: [
        ['m', 3367, 2580],
        ['l', 3195, 2417],
        ['l', 2204, 3482],
        ['l', 1253, 2458],
        ['l', 1196, 2499],
        ['l', 2318, 3686],
        ['l', 3367, 2580],
      ],
    },
    _: {
      xoff: 3584,
      width: 2240,
      height: 128,
      hbx: 640,
      hby: 128,
      path: [
        ['m', 647, 66],
        ['l', 2859, 66],
        ['l', 2859, 0],
        ['l', 647, 0],
        ['l', 647, 66],
      ],
    },
    '`': {
      xoff: 2432,
      width: 1024,
      height: 1216,
      hbx: 832,
      hby: 5824,
      path: [
        ['m', 836, 5816],
        ['l', 1425, 5800],
        ['l', 1802, 4645],
        ['l', 1696, 4645],
        ['l', 836, 5816],
      ],
    },
    a: {
      xoff: 4224,
      width: 3712,
      height: 4224,
      hbx: 256,
      hby: 4160,
      path: [
        ['m', 3711, 0],
        ['q', 3154, 0, 2949, 213],
        ['q', 2761, 393, 2761, 524],
        ['l', 2761, 696],
        ['q', 2359, -33, 1475, -33],
        ['q', 442, -33, 303, 901],
        ['q', 287, 999, 287, 1101],
        ['q', 287, 1204, 319, 1327],
        ['q', 352, 1450, 508, 1597],
        ['q', 819, 1892, 1876, 1958],
        ['q', 2138, 1982, 2359, 1982],
        ['q', 2580, 1982, 2761, 1966],
        ['l', 2761, 3326],
        ['q', 2744, 3334, 2760, 3403],
        ['q', 2777, 3473, 2732, 3584],
        ['q', 2687, 3695, 2613, 3801],
        ['q', 2540, 3908, 2351, 3985],
        ['q', 2163, 4063, 1859, 4063],
        ['q', 1556, 4063, 1150, 3952],
        ['q', 745, 3842, 557, 3736],
        ['l', 524, 3793],
        ['q', 1253, 4129, 2007, 4129],
        ['q', 2851, 4129, 3121, 3826],
        ['q', 3334, 3588, 3334, 3326],
        ['l', 3334, 582],
        ['q', 3334, 344, 3428, 217],
        ['q', 3523, 90, 3621, 82],
        ['l', 3711, 66],
        ['l', 3965, 66],
        ['l', 3965, 0],
        ['l', 3711, 0],
        ['m', 1606, 33],
        ['q', 2040, 33, 2388, 332],
        ['q', 2736, 631, 2761, 909],
        ['l', 2761, 1901],
        ['q', 2540, 1917, 2314, 1917],
        ['q', 2089, 1917, 1868, 1892],
        ['q', 1245, 1819, 1056, 1614],
        ['q', 868, 1409, 868, 1049],
        ['q', 868, 983, 877, 901],
        ['q', 950, 33, 1606, 33],
      ],
    },
    b: {
      xoff: 4288,
      width: 3648,
      height: 6208,
      hbx: 320,
      hby: 6144,
      path: [
        ['m', 328, 6136],
        ['l', 901, 6136],
        ['l', 901, 3080],
        ['q', 1040, 3457, 1417, 3793],
        ['q', 1794, 4129, 2269, 4129],
        ['q', 3932, 4129, 3932, 2179],
        ['q', 3932, -33, 1786, -33],
        ['q', 1155, -33, 328, 172],
        ['l', 328, 6136],
        ['m', 2261, 4063],
        ['q', 1753, 4063, 1343, 3625],
        ['q', 934, 3187, 901, 2834],
        ['l', 901, 221],
        ['q', 1401, 33, 1778, 33],
        ['q', 3359, 33, 3359, 2187],
        ['q', 3359, 4063, 2261, 4063],
      ],
    },
    c: {
      xoff: 3968,
      width: 3392,
      height: 4224,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 2245, 4063],
        ['q', 1663, 4063, 1274, 3506],
        ['q', 885, 2949, 885, 1966],
        ['q', 885, 983, 1241, 508],
        ['q', 1597, 33, 2179, 33],
        ['q', 2908, 33, 3473, 279],
        ['l', 3498, 221],
        ['q', 2916, -33, 2138, -33],
        ['q', 1360, -33, 844, 458],
        ['q', 328, 950, 328, 1974],
        ['q', 328, 2998, 868, 3563],
        ['q', 1409, 4129, 2245, 4129],
        ['q', 2712, 4129, 3109, 3916],
        ['q', 3506, 3703, 3695, 3269],
        ['l', 3170, 3269],
        ['q', 3047, 3670, 2797, 3866],
        ['q', 2548, 4063, 2245, 4063],
      ],
    },
    d: {
      xoff: 4928,
      width: 4288,
      height: 6208,
      hbx: 320,
      hby: 6144,
      path: [
        ['m', 328, 1901],
        ['q', 328, 2966, 844, 3547],
        ['q', 1360, 4129, 2392, 4129],
        ['q', 2875, 4129, 3367, 3883],
        ['l', 3367, 6136],
        ['l', 3940, 6136],
        ['l', 3940, 582],
        ['q', 3940, 344, 4034, 217],
        ['q', 4129, 90, 4227, 82],
        ['l', 4317, 66],
        ['l', 4571, 66],
        ['l', 4571, 0],
        ['l', 4071, 0],
        ['q', 3736, 0, 3559, 147],
        ['q', 3383, 295, 3375, 442],
        ['l', 3367, 582],
        ['l', 3367, 713],
        ['q', 3211, 426, 2850, 205],
        ['q', 2490, -16, 1999, -16],
        ['q', 328, 25, 328, 1901],
        ['m', 2007, 49],
        ['q', 2556, 49, 2949, 344],
        ['q', 3342, 639, 3367, 926],
        ['l', 3367, 3809],
        ['q', 2785, 4063, 2367, 4063],
        ['q', 1638, 4063, 1269, 3494],
        ['q', 901, 2925, 901, 1901],
        ['q', 901, 49, 2007, 49],
      ],
    },
    e: {
      xoff: 4096,
      width: 3520,
      height: 4224,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 885, 1999],
        ['q', 885, 983, 1241, 508],
        ['q', 1597, 33, 2179, 33],
        ['q', 2998, 33, 3637, 279],
        ['l', 3662, 221],
        ['q', 3006, -33, 2183, -33],
        ['q', 1360, -33, 844, 458],
        ['q', 328, 950, 328, 1974],
        ['q', 328, 2998, 868, 3563],
        ['q', 1409, 4129, 2245, 4129],
        ['q', 2916, 4129, 3375, 3727],
        ['q', 3834, 3326, 3834, 2540],
        ['q', 3834, 2499, 3834, 2458],
        ['l', 909, 2458],
        ['q', 885, 2236, 885, 1999],
        ['m', 3277, 2523],
        ['q', 3269, 3310, 2974, 3686],
        ['q', 2679, 4063, 2212, 4063],
        ['q', 1745, 4063, 1380, 3653],
        ['q', 1016, 3244, 918, 2523],
        ['l', 3277, 2523],
      ],
    },
    f: {
      xoff: 2112,
      width: 1856,
      height: 6144,
      hbx: 256,
      hby: 6144,
      path: [
        ['m', 1032, 4481],
        ['l', 1032, 4096],
        ['l', 1679, 4096],
        ['l', 1679, 4030],
        ['l', 1032, 4030],
        ['l', 1032, 0],
        ['l', 459, 0],
        ['l', 459, 4030],
        ['l', 287, 4030],
        ['l', 287, 4096],
        ['l', 459, 4096],
        ['l', 459, 4481],
        ['q', 459, 5374, 844, 5755],
        ['q', 1229, 6136, 2089, 6144],
        ['l', 2089, 6078],
        ['q', 1524, 6070, 1278, 5697],
        ['q', 1032, 5325, 1032, 4481],
      ],
    },
    g: {
      xoff: 4160,
      width: 3648,
      height: 6208,
      hbx: 256,
      hby: 4160,
      path: [
        ['m', 287, 1901],
        ['q', 287, 2966, 803, 3547],
        ['q', 1319, 4129, 2351, 4129],
        ['q', 3113, 4129, 3899, 3858],
        ['l', 3899, -98],
        ['q', 3891, -2048, 2195, -2048],
        ['q', 1262, -2048, 598, -1442],
        ['l', 655, -1393],
        ['q', 1360, -1982, 2195, -1982],
        ['q', 3326, -1982, 3326, -98],
        ['l', 3326, 713],
        ['q', 3170, 426, 2809, 205],
        ['q', 2449, -16, 1958, -16],
        ['q', 287, 25, 287, 1901],
        ['m', 1966, 49],
        ['q', 2515, 49, 2908, 344],
        ['q', 3301, 639, 3326, 926],
        ['l', 3326, 3817],
        ['q', 2736, 4063, 2327, 4063],
        ['q', 1597, 4063, 1228, 3494],
        ['q', 860, 2925, 860, 1901],
        ['q', 860, 49, 1966, 49],
      ],
    },
    h: {
      xoff: 4544,
      width: 3904,
      height: 6144,
      hbx: 384,
      hby: 6144,
      path: [
        ['m', 3768, 0],
        ['q', 3432, 0, 3256, 147],
        ['q', 3080, 295, 3072, 442],
        ['l', 3064, 582],
        ['l', 3064, 3154],
        ['q', 3064, 3801, 2720, 3981],
        ['q', 2556, 4063, 2302, 4063],
        ['q', 1794, 4063, 1388, 3649],
        ['q', 983, 3236, 983, 2908],
        ['l', 983, 0],
        ['l', 410, 0],
        ['l', 410, 6136],
        ['l', 983, 6136],
        ['l', 983, 3162],
        ['q', 1114, 3514, 1482, 3821],
        ['q', 1851, 4129, 2310, 4129],
        ['q', 3105, 4129, 3371, 3854],
        ['q', 3637, 3580, 3637, 3146],
        ['l', 3637, 582],
        ['q', 3637, 344, 3731, 217],
        ['q', 3826, 90, 3916, 82],
        ['l', 4014, 66],
        ['l', 4268, 66],
        ['l', 4268, 0],
        ['l', 3768, 0],
      ],
    },
    i: {
      xoff: 1984,
      width: 1280,
      height: 5632,
      hbx: 384,
      hby: 5632,
      path: [
        ['m', 1163, 0],
        ['q', 827, 0, 651, 147],
        ['q', 475, 295, 467, 442],
        ['l', 459, 582],
        ['l', 459, 4096],
        ['l', 1032, 4096],
        ['l', 1032, 582],
        ['q', 1032, 344, 1126, 217],
        ['q', 1221, 90, 1311, 82],
        ['l', 1409, 66],
        ['l', 1663, 66],
        ['l', 1663, 0],
        ['l', 1163, 0],
        ['m', 508, 5013],
        ['q', 410, 5112, 410, 5259],
        ['q', 410, 5407, 508, 5509],
        ['q', 606, 5612, 753, 5612],
        ['q', 901, 5612, 1003, 5509],
        ['q', 1106, 5407, 1106, 5259],
        ['q', 1106, 5112, 1003, 5013],
        ['q', 901, 4915, 753, 4915],
        ['q', 606, 4915, 508, 5013],
      ],
    },
    j: {
      xoff: 1920,
      width: 2112,
      height: 7680,
      hbx: -512,
      hby: 5632,
      path: [
        ['m', -492, -1892],
        ['l', -467, -1827],
        ['q', -74, -1982, 307, -1982],
        ['q', 688, -1982, 807, -1744],
        ['q', 926, -1507, 926, -975],
        ['l', 926, 4096],
        ['l', 1499, 4096],
        ['l', 1499, -967],
        ['q', 1499, -1614, 1237, -1831],
        ['q', 975, -2048, 446, -2048],
        ['q', -82, -2048, -492, -1892],
        ['m', 966, 5013],
        ['q', 868, 5112, 868, 5259],
        ['q', 868, 5407, 966, 5509],
        ['q', 1065, 5612, 1212, 5612],
        ['q', 1360, 5612, 1462, 5509],
        ['q', 1565, 5407, 1565, 5259],
        ['q', 1565, 5112, 1462, 5013],
        ['q', 1360, 4915, 1212, 4915],
        ['q', 1065, 4915, 966, 5013],
      ],
    },
    k: {
      xoff: 3584,
      width: 2944,
      height: 6144,
      hbx: 384,
      hby: 6144,
      path: [
        ['m', 983, 6144],
        ['l', 983, 2064],
        ['l', 2785, 4096],
        ['l', 2867, 4096],
        ['l', 1532, 2589],
        ['l', 3293, 0],
        ['l', 2720, 0],
        ['l', 1204, 2228],
        ['l', 983, 1974],
        ['l', 983, 0],
        ['l', 410, 0],
        ['l', 410, 6144],
        ['l', 983, 6144],
      ],
    },
    l: {
      xoff: 1920,
      width: 1280,
      height: 6144,
      hbx: 384,
      hby: 6144,
      path: [
        ['m', 1368, 0],
        ['q', 647, 0, 459, 377],
        ['q', 418, 459, 418, 524],
        ['l', 418, 6136],
        ['l', 991, 6136],
        ['l', 991, 582],
        ['q', 991, 344, 1085, 217],
        ['q', 1180, 90, 1278, 82],
        ['l', 1368, 66],
        ['l', 1622, 66],
        ['l', 1622, 0],
        ['l', 1368, 0],
      ],
    },
    m: {
      xoff: 6528,
      width: 6208,
      height: 4160,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 5267, 3154],
        ['q', 5267, 3654, 5136, 3858],
        ['q', 5005, 4063, 4637, 4063],
        ['q', 4145, 4063, 3764, 3653],
        ['q', 3383, 3244, 3383, 2916],
        ['l', 3383, 0],
        ['l', 2810, 0],
        ['l', 2810, 3154],
        ['q', 2810, 3654, 2679, 3858],
        ['q', 2548, 4063, 2122, 4063],
        ['q', 1696, 4063, 1315, 3670],
        ['q', 934, 3277, 901, 2941],
        ['l', 901, 0],
        ['l', 328, 0],
        ['l', 328, 4096],
        ['l', 901, 4096],
        ['l', 901, 3170],
        ['q', 1032, 3523, 1384, 3826],
        ['q', 1737, 4129, 2171, 4129],
        ['q', 2605, 4129, 2863, 4051],
        ['q', 3121, 3973, 3227, 3809],
        ['q', 3334, 3645, 3358, 3522],
        ['q', 3383, 3400, 3383, 3178],
        ['q', 3514, 3531, 3858, 3830],
        ['q', 4202, 4129, 4595, 4129],
        ['q', 4989, 4129, 5226, 4063],
        ['q', 5464, 3998, 5583, 3916],
        ['q', 5702, 3834, 5763, 3678],
        ['q', 5825, 3523, 5833, 3424],
        ['q', 5841, 3326, 5841, 3146],
        ['l', 5841, 582],
        ['q', 5841, 344, 5935, 217],
        ['q', 6029, 90, 6128, 82],
        ['l', 6218, 66],
        ['l', 6472, 66],
        ['l', 6472, 0],
        ['l', 5972, 0],
        ['q', 5636, 0, 5460, 147],
        ['q', 5284, 295, 5276, 442],
        ['l', 5267, 582],
        ['l', 5267, 3154],
      ],
    },
    n: {
      xoff: 4288,
      width: 3968,
      height: 4160,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 3727, 0],
        ['q', 3391, 0, 3215, 147],
        ['q', 3039, 295, 3031, 442],
        ['l', 3023, 582],
        ['l', 3023, 3154],
        ['q', 3023, 3801, 2687, 3981],
        ['q', 2515, 4063, 2261, 4063],
        ['q', 1737, 4063, 1319, 3649],
        ['q', 901, 3236, 901, 2908],
        ['l', 901, 0],
        ['l', 328, 0],
        ['l', 328, 4096],
        ['l', 901, 4096],
        ['l', 901, 3162],
        ['q', 1040, 3514, 1417, 3821],
        ['q', 1794, 4129, 2244, 4129],
        ['q', 2695, 4129, 2977, 4043],
        ['q', 3260, 3957, 3391, 3801],
        ['q', 3596, 3547, 3596, 3146],
        ['l', 3596, 582],
        ['q', 3596, 344, 3690, 217],
        ['q', 3785, 90, 3883, 82],
        ['l', 3973, 66],
        ['l', 4227, 66],
        ['l', 4227, 0],
        ['l', 3727, 0],
      ],
    },
    o: {
      xoff: 4608,
      width: 3968,
      height: 4224,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 2273, -33],
        ['q', 1409, -33, 868, 458],
        ['q', 328, 950, 328, 1974],
        ['q', 328, 2998, 889, 3563],
        ['q', 1450, 4129, 2314, 4129],
        ['q', 3178, 4129, 3719, 3637],
        ['q', 4260, 3146, 4260, 2122],
        ['q', 4260, 1098, 3699, 532],
        ['q', 3138, -33, 2273, -33],
        ['m', 2326, 4063],
        ['q', 1704, 4063, 1294, 3510],
        ['q', 885, 2957, 885, 1970],
        ['q', 885, 983, 1261, 508],
        ['q', 1638, 33, 2261, 33],
        ['q', 2884, 33, 3293, 586],
        ['q', 3703, 1139, 3703, 2126],
        ['q', 3703, 3113, 3326, 3588],
        ['q', 2949, 4063, 2326, 4063],
      ],
    },
    p: {
      xoff: 4352,
      width: 3648,
      height: 6208,
      hbx: 384,
      hby: 4160,
      path: [
        ['m', 410, 4096],
        ['l', 983, 4096],
        ['l', 983, 3080],
        ['q', 1122, 3457, 1499, 3793],
        ['q', 1876, 4129, 2351, 4129],
        ['q', 4014, 4129, 4014, 2179],
        ['q', 4014, -33, 1868, -33],
        ['q', 1483, -33, 983, 147],
        ['l', 983, -2048],
        ['l', 410, -2048],
        ['l', 410, 4096],
        ['m', 2343, 4063],
        ['q', 1835, 4063, 1425, 3625],
        ['q', 1016, 3187, 983, 2834],
        ['l', 983, 221],
        ['q', 1483, 33, 1860, 33],
        ['q', 3441, 33, 3441, 2187],
        ['q', 3441, 4063, 2343, 4063],
      ],
    },
    q: {
      xoff: 4288,
      width: 3648,
      height: 6208,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 328, 1901],
        ['q', 328, 2966, 844, 3547],
        ['q', 1360, 4129, 2392, 4129],
        ['q', 2875, 4129, 3367, 3883],
        ['l', 3367, 4096],
        ['l', 3940, 4096],
        ['l', 3940, -2048],
        ['l', 3367, -2048],
        ['l', 3367, 713],
        ['q', 3211, 426, 2850, 205],
        ['q', 2490, -16, 1999, -16],
        ['q', 328, 25, 328, 1901],
        ['m', 2007, 49],
        ['q', 2556, 49, 2949, 344],
        ['q', 3342, 639, 3367, 926],
        ['l', 3367, 3809],
        ['q', 2785, 4063, 2367, 4063],
        ['q', 1638, 4063, 1269, 3494],
        ['q', 901, 2925, 901, 1901],
        ['q', 901, 49, 2007, 49],
      ],
    },
    r: {
      xoff: 2944,
      width: 2368,
      height: 4160,
      hbx: 320,
      hby: 4160,
      path: [
        ['m', 1892, 3744],
        ['l', 1892, 3916],
        ['q', 1524, 3768, 1221, 3321],
        ['q', 918, 2875, 901, 2482],
        ['l', 901, 0],
        ['l', 328, 0],
        ['l', 328, 4096],
        ['l', 901, 4096],
        ['l', 901, 2793],
        ['q', 1032, 3269, 1400, 3690],
        ['q', 1769, 4112, 2236, 4129],
        ['l', 2269, 4129],
        ['q', 2433, 4129, 2543, 4018],
        ['q', 2654, 3908, 2654, 3744],
        ['q', 2654, 3580, 2543, 3473],
        ['q', 2433, 3367, 2269, 3367],
        ['q', 2105, 3367, 1998, 3473],
        ['q', 1892, 3580, 1892, 3744],
      ],
    },
    s: {
      xoff: 3456,
      width: 2944,
      height: 4224,
      hbx: 256,
      hby: 4160,
      path: [
        ['m', 2720, 3809],
        ['q', 2589, 3916, 2298, 3989],
        ['q', 2007, 4063, 1859, 4063],
        ['q', 1712, 4063, 1688, 4063],
        ['q', 1245, 4055, 1048, 3838],
        ['q', 852, 3621, 852, 3350],
        ['q', 852, 3080, 1024, 2896],
        ['q', 1196, 2712, 1454, 2609],
        ['q', 1712, 2507, 2011, 2376],
        ['q', 2310, 2245, 2568, 2109],
        ['q', 2826, 1974, 2998, 1716],
        ['q', 3170, 1458, 3170, 1073],
        ['q', 3170, 688, 2900, 417],
        ['q', 2630, 147, 2298, 57],
        ['q', 1966, -33, 1581, -33],
        ['q', 745, -33, 328, 336],
        ['l', 377, 385],
        ['q', 541, 229, 864, 131],
        ['q', 1188, 33, 1491, 33],
        ['q', 1974, 33, 2289, 299],
        ['q', 2605, 565, 2605, 962],
        ['q', 2605, 1360, 2367, 1601],
        ['q', 2130, 1843, 1790, 1978],
        ['q', 1450, 2114, 1106, 2249],
        ['q', 762, 2384, 524, 2625],
        ['q', 287, 2867, 287, 3186],
        ['q', 287, 3506, 434, 3707],
        ['q', 582, 3908, 827, 3990],
        ['q', 1245, 4129, 1663, 4129],
        ['q', 2367, 4129, 2761, 3867],
        ['l', 2720, 3809],
      ],
    },
    t: {
      xoff: 2752,
      width: 2240,
      height: 4992,
      hbx: 256,
      hby: 4928,
      path: [
        ['m', 287, 4030],
        ['l', 287, 4096],
        ['l', 459, 4096],
        ['l', 459, 4915],
        ['l', 1032, 4915],
        ['l', 1032, 4096],
        ['l', 2286, 4096],
        ['l', 2286, 4030],
        ['l', 1032, 4030],
        ['l', 1032, 1049],
        ['q', 1032, 516, 1151, 278],
        ['q', 1270, 41, 1651, 41],
        ['q', 2032, 41, 2425, 197],
        ['l', 2449, 131],
        ['q', 2040, -25, 1511, -25],
        ['q', 983, -25, 721, 192],
        ['q', 459, 410, 459, 1057],
        ['l', 459, 4030],
        ['l', 287, 4030],
      ],
    },
    u: {
      xoff: 4288,
      width: 3968,
      height: 4160,
      hbx: 320,
      hby: 4096,
      path: [
        ['m', 901, 942],
        ['q', 901, 295, 1245, 115],
        ['q', 1409, 33, 1663, 33],
        ['q', 2179, 33, 2584, 426],
        ['q', 2990, 819, 3023, 1155],
        ['l', 3023, 4096],
        ['l', 3596, 4096],
        ['l', 3596, 582],
        ['q', 3596, 344, 3690, 217],
        ['q', 3785, 90, 3883, 82],
        ['l', 3973, 66],
        ['l', 4227, 66],
        ['l', 4227, 0],
        ['l', 3727, 0],
        ['q', 3391, 0, 3215, 147],
        ['q', 3039, 295, 3031, 442],
        ['l', 3023, 582],
        ['l', 3023, 934],
        ['q', 2875, 582, 2498, 274],
        ['q', 2122, -33, 1675, -33],
        ['q', 1229, -33, 946, 53],
        ['q', 664, 139, 541, 295],
        ['q', 328, 549, 328, 950],
        ['l', 328, 4096],
        ['l', 901, 4096],
        ['l', 901, 942],
      ],
    },
    v: {
      xoff: 3840,
      width: 3328,
      height: 4096,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 3351, 4047],
        ['l', 3400, 4096],
        ['q', 3432, 4080, 3485, 3998],
        ['q', 3539, 3916, 3551, 3850],
        ['q', 3564, 3785, 3564, 3727],
        ['q', 3564, 3506, 3465, 3277],
        ['l', 1892, 0],
        ['l', 1810, 0],
        ['l', 287, 4096],
        ['l', 860, 4096],
        ['l', 2114, 705],
        ['l', 3383, 3277],
        ['q', 3482, 3449, 3482, 3686],
        ['q', 3482, 3924, 3351, 4047],
      ],
    },
    w: {
      xoff: 6464,
      width: 5952,
      height: 4096,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 5972, 4047],
        ['l', 6021, 4096],
        ['q', 6054, 4080, 6107, 3998],
        ['q', 6160, 3916, 6172, 3850],
        ['q', 6185, 3785, 6185, 3727],
        ['q', 6185, 3506, 6087, 3277],
        ['l', 4596, 0],
        ['l', 4514, 0],
        ['l', 3334, 3170],
        ['l', 1892, 0],
        ['l', 1810, 0],
        ['l', 287, 4096],
        ['l', 860, 4096],
        ['l', 2114, 705],
        ['l', 3293, 3269],
        ['l', 2990, 4096],
        ['l', 3564, 4096],
        ['l', 4817, 705],
        ['l', 6005, 3277],
        ['q', 6103, 3449, 6103, 3686],
        ['q', 6103, 3924, 5972, 4047],
      ],
    },
    x: {
      xoff: 4160,
      width: 3648,
      height: 4096,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 287, 0],
        ['l', 287, 66],
        ['q', 459, 66, 635, 197],
        ['q', 811, 328, 901, 459],
        ['l', 1925, 1966],
        ['l', 467, 4096],
        ['l', 1065, 4096],
        ['l', 2318, 2269],
        ['l', 3531, 4096],
        ['l', 3613, 4096],
        ['l', 2351, 2212],
        ['l', 3875, 0],
        ['l', 3277, 0],
        ['l', 1958, 1917],
        ['l', 1073, 590],
        ['q', 1057, 565, 1032, 524],
        ['q', 1008, 483, 926, 385],
        ['q', 844, 287, 754, 213],
        ['q', 508, 0, 287, 0],
      ],
    },
    y: {
      xoff: 3968,
      width: 3456,
      height: 6144,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 1335, -1466],
        ['q', 1073, -2048, 688, -2048],
        ['q', 516, -2048, 287, -1991],
        ['l', 287, -1925],
        ['q', 475, -1974, 623, -1974],
        ['q', 1040, -1974, 1262, -1466],
        ['l', 1950, 0],
        ['l', 1942, 0],
        ['l', 418, 4096],
        ['l', 991, 4096],
        ['l', 2261, 680],
        ['l', 3514, 3277],
        ['q', 3613, 3449, 3613, 3686],
        ['q', 3613, 3924, 3482, 4047],
        ['l', 3531, 4096],
        ['q', 3564, 4080, 3617, 3998],
        ['q', 3670, 3916, 3682, 3850],
        ['q', 3695, 3785, 3695, 3727],
        ['q', 3695, 3506, 3596, 3277],
        ['l', 2023, 0],
        ['l', 1335, -1466],
      ],
    },
    z: {
      xoff: 3840,
      width: 3328,
      height: 4096,
      hbx: 256,
      hby: 4096,
      path: [
        ['m', 492, 4030],
        ['l', 492, 4096],
        ['l', 3334, 4096],
        ['l', 3334, 4030],
        ['l', 860, 66],
        ['l', 2818, 66],
        ['q', 3383, 66, 3498, 393],
        ['l', 3547, 369],
        ['q', 3547, 336, 3489, 258],
        ['q', 3432, 180, 3359, 131],
        ['q', 3162, 0, 2818, 0],
        ['l', 287, 0],
        ['l', 287, 66],
        ['l', 2761, 4030],
        ['l', 492, 4030],
      ],
    },
    '{': {
      xoff: 3264,
      width: 1728,
      height: 8064,
      hbx: 768,
      hby: 6144,
      path: [
        ['m', 1245, 3146],
        ['l', 1245, 5226],
        ['q', 1245, 5816, 1769, 6005],
        ['q', 2040, 6103, 2458, 6144],
        ['l', 2458, 6070],
        ['q', 2023, 5947, 1942, 5636],
        ['q', 1901, 5480, 1901, 5251],
        ['l', 1901, 3170],
        ['q', 1901, 2286, 999, 2114],
        ['q', 1901, 1925, 1901, 1057],
        ['l', 1901, -1024],
        ['q', 1901, -1491, 2081, -1647],
        ['q', 2228, -1778, 2458, -1843],
        ['l', 2458, -1917],
        ['q', 1729, -1835, 1491, -1622],
        ['q', 1245, -1393, 1245, -999],
        ['l', 1245, 1081],
        ['q', 1245, 1958, 819, 2081],
        ['l', 819, 2146],
        ['q', 1245, 2269, 1245, 3146],
      ],
    },
    '|': {
      xoff: 2304,
      width: 704,
      height: 7488,
      hbx: 704,
      hby: 6144,
      path: [
        ['m', 713, 6144],
        ['l', 1368, 6144],
        ['l', 1368, -1343],
        ['l', 713, -1343],
        ['l', 713, 6144],
      ],
    },
    '}': {
      xoff: 3264,
      width: 1728,
      height: 8064,
      hbx: 768,
      hby: 6144,
      path: [
        ['m', 2032, 1081],
        ['l', 2032, -999],
        ['q', 2032, -1589, 1507, -1778],
        ['q', 1237, -1876, 819, -1917],
        ['l', 819, -1843],
        ['q', 1253, -1720, 1335, -1409],
        ['q', 1376, -1253, 1376, -1024],
        ['l', 1376, 1057],
        ['q', 1376, 1925, 2277, 2114],
        ['q', 1376, 2286, 1376, 3170],
        ['l', 1376, 5251],
        ['q', 1376, 5718, 1196, 5874],
        ['q', 1049, 6005, 819, 6070],
        ['l', 819, 6144],
        ['q', 1548, 6062, 1786, 5849],
        ['q', 2032, 5620, 2032, 5226],
        ['l', 2032, 3146],
        ['q', 2032, 2269, 2458, 2146],
        ['l', 2458, 2081],
        ['q', 2032, 1958, 2032, 1081],
      ],
    },
    '~': {
      xoff: 4800,
      width: 2752,
      height: 512,
      hbx: 1152,
      hby: 2944,
      path: [
        ['m', 1180, 2474],
        ['q', 1270, 2859, 1679, 2859],
        ['q', 2007, 2859, 2540, 2703],
        ['q', 3138, 2572, 3363, 2572],
        ['q', 3588, 2572, 3678, 2633],
        ['q', 3768, 2695, 3809, 2892],
        ['l', 3883, 2875],
        ['q', 3809, 2523, 3490, 2490],
        ['q', 3432, 2482, 3264, 2482],
        ['q', 3097, 2482, 2712, 2605],
        ['q', 2589, 2630, 2294, 2695],
        ['q', 1942, 2777, 1716, 2777],
        ['q', 1491, 2777, 1397, 2711],
        ['q', 1303, 2646, 1262, 2458],
        ['l', 1180, 2474],
      ],
    },
  },
  exporter: 'SimpleJson',
  version: '0.0.6',
};
